import { select, selectAll, selectEntities } from './applicationSelectors';

export const selectSchoolEntities = selectEntities('schools');
export const selectSchools = selectAll(selectSchoolEntities);
export const selectSchool = select(selectSchoolEntities);
